import { BaseRouteService } from "core/services";

class FacilityOrderTemplateNoteRouteService extends BaseRouteService {
	constructor() {
		super("facility-order-template-notes");	
	}
	
	get(id, options) {		
		return super.get(`${this.base}/{id}{?embed,fields}`, id, options);	
	}
	
	create(resource) {		
		return super.create(this.base, resource);	
	}

	update(resource) {
		return super.update(`${this.base}/{id}`, resource);	
	}	
}

export default FacilityOrderTemplateNoteRouteService;
